// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0cc41502","453":"e6606d9f","455":"9917e43b","977":"7383e41c"}[chunkId] + ".chunk.js";
};